/** The greeting the owner decided to show; every display window reads it and
 *  the one under the pointer renders it in the agent cursor. */
import { create } from "zustand";
import { mirroredStore } from "@/lib/mirrored-store";
import type { IdleGreetingVariant } from "./idle-greeting-copy";

/** How long a tip stays before it retracts on its own. */
export const IDLE_GREETING_HOLD_MS = 6_000;
/** The launch message is read once: it stays longer. */
export const LAUNCH_MESSAGE_HOLD_MS = 12_000;

/** A shortcut tip for a new user, or a returning user's one launch message:
 *  an unseen release highlight, else the welcome (the talk tip). */
export type GreetingMessage =
  | { kind: "tip"; variant: IdleGreetingVariant }
  | { kind: "highlight"; text: string }
  | { kind: "welcome" };

/** `id` is when the owner showed it (`Date.now()`). */
export type IdleGreeting = { id: number; message: GreetingMessage };

export function greetingHoldMs(message: GreetingMessage): number {
  return message.kind === "tip"
    ? IDLE_GREETING_HOLD_MS
    : LAUNCH_MESSAGE_HOLD_MS;
}

type IdleGreetingState = { greeting: IdleGreeting | null };

export const useIdleGreeting = create<IdleGreetingState>()(
  mirroredStore<IdleGreetingState>("idleGreeting", () => ({
    greeting: null,
  })),
);
